import { useEffect, useRef } from "react";
import L from "leaflet";

const WMS = "https://service.pdok.nl/hwh/luchtfotorgb/wms/v1_0";
const layerName = (y) => (y >= 2021 ? `${y}_orthoHR` : `${y}_ortho25`);

export const PerceelMap = ({ address, year }) => {
  const el = useRef(null);
  const map = useRef(null);
  const photo = useRef(null);

  useEffect(() => {
    const m = L.map(el.current, { zoomControl: true, attributionControl: true, maxZoom: 21 });
    map.current = m;
    photo.current = L.tileLayer.wms(WMS, { layers: layerName(year), format: "image/jpeg", maxZoom: 21, attribution: "PDOK Luchtfoto" }).addTo(m);
    const p = address.perceel?.geom_wgs;
    if (p) {
      const pl = L.geoJSON(p, { style: { color: "#38BDF8", weight: 2.5, fillColor: "#38BDF8", fillOpacity: 0.12 } }).addTo(m);
      m.fitBounds(pl.getBounds(), { padding: [30, 30] });
    } else m.setView([address.lat, address.lon], 19);
    (address.panden || []).forEach((pd) =>
      L.geoJSON(pd.geom_wgs, { style: { color: "#F59E0B", weight: 1.5, fillOpacity: 0.08, dashArray: "4 3" } })
        .bindTooltip(`Pand ${pd.identificatie} · bouwjaar ${pd.bouwjaar} · ${pd.oppervlakte_m2} m²`).addTo(m));
    L.circleMarker([address.lat, address.lon], { radius: 5, color: "#fff", fillColor: "#2563EB", fillOpacity: 1, weight: 2 }).addTo(m);
    return () => m.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address.id]);

  useEffect(() => {
    photo.current?.setParams({ layers: layerName(year) });
  }, [year]);

  return <div ref={el} data-testid="perceel-map" className="relative z-0 isolate w-full h-full min-h-[360px] rounded-md border border-slate-800" />;
};
